export default __webpack_public_path__ + "static/media/video.2994a904.mp4";